var SellerModule = (function () {
    function SellerModule() {
    }
    return SellerModule;
}());
export { SellerModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/seller/seller.module.ts.pre-build-optimizer.js